import styled, { css } from "styled-components";
import { Button } from "@material-ui/core";
import { device } from "./constants";
import { Modal } from "reactstrap";

export const ViewHubParaContainer = styled.div`
    padding: 20px;
    font-family: Verdana;
    > h3 {
        color: #333333;
        margin-bottom: 5px;
        font-family: Verdana;
    }
    > label {
        color: #333333;
        margin-bottom: 0;
        margin-left: 1px;
    }
`;

export const SubHeaderSection = styled.div`
    display: flex;
    font-weight: 600;
    margin-bottom: 5px;
    > label#hub_server_status {
        margin-bottom: 0;
        color: #363636;
    }
    > label#hub_server_running_status {
        margin-bottom: 0;
        margin-left: 45px;
        color: #363636;
    }
`;

export const HyperLinkDiv = styled.div`
    cursor: pointer;
    color: #6890c6;
`;

export const ViewTableContainer = styled.div`
    /* border: 2px solid lightgray; */
    overflow: auto;
    width: 80%; // for larger desktop screens
    margin: 0px 30px 15px 10px;
    @media ${device.laptopL} {
        min-width: 90%;
    }
    @media ${device.laptopM} {
        min-width: 97%;
    }
    @media ${device.laptop} {
        min-width: 100%;
    }
    table {
        font-family: Verdana;
        tbody {
            tr {
                height: 45px;
                td {
                    color: #333333;
                    font-size: 1rem;
                    border: none;
                    white-space: nowrap;
                    padding: 0px 24px 0px 24px;
                    button {
                        width: 120px;
                        color: #1c1a1a;
                        height: 27px;
                        font-size: 12px;
                        text-transform: capitalize;
                        border: 1px solid #cccccc;
                        border-radius: 1px !important;
                    }
                    > label {
                        font-weight: 600;
                    }
                }
                td:first-child {
                    font-weight: 600;
                    /* font-size: 0.94rem; */
                }
            }
        }
    }
`;

export const EditTableContainer = styled.div`
    /* border: 2px solid lightgray; */
    margin: 20px;
    /* overflow: auto; */
    width: 70%;
    min-height: 75px;
    table {
        font-family: Verdana;
        tbody {
            tr {
                height: 45px;
                td {
                    color: #333333;
                    font-size: 1rem;
                    border: none;
                    white-space: nowrap;
                    padding: 0px 24px 0px 24px;
                }
                td:first-child {
                    font-weight: 600;
                    width: 275px;
                    /* font-size: 0.94rem; */
                }
            }
        }
    }
`;

export const BackButtonContainer = styled.div`
    padding-left: 16px;
    button {
        width: 105px;
        color: #fff;
        height: 29px;
        text-transform: capitalize;
        background-color: #eeeeee;
        color: #181d1f;
        border-radius: 15px !important;
        margin-top: 4px;
        font-size: 1.1rem;
        font-family: Verdana;
        padding: 16px 15px;
        &:hover {
            background-color: #cccccc;
        }
        svg {
            margin-right: 3px;
            font-size: 12px;
        }
    }
    button#edit-button {
        background-color: #4c912d;
        color: #fff;
        &:hover {
            background-color: #467c26;
        }
    }
`;

export const ErrorSectionDiv = styled.div`
    margin: 0 20px 0 0;
    svg {
        color: #C31200;
        margin-right: 9px;
        font-size: 20px;
        margin-bottom: 2px;
    }
    label {
        color: #585858;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 0;
        word-break: break-all;
        white-space: break-spaces;
    }
`;

export const SpinnerContainer = styled.div`
    position: absolute;
    width: 75%;
    height: 380px;
`;

export const AutoGenDiv = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    label {
        margin-bottom: 1px;
        margin-left: 5px;
        cursor: pointer;
    }
`;

export const GenCSRButton = styled(Button)`
    background-color: #4c912d !important;
    color: #fff !important;
    height: 27px;
    font-size: 1rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    font-family: Verdana !important;
    margin-top: -13px !important;
    border-radius: 15px !important;
    padding: 15px !important;
`;

export const EditActions = styled.div`
    display: flex;
    #cancel_button, #apply_button {
        height: 29px;
        ${props => (props.isOverwriteModel ? css`width: 165px;` : css`width: 105px;` )}
        color: #fff;
        text-transform: none;
        font-size: 1.1rem;
        font-family: Verdana;
        border-radius: 20px !important;
        padding: 16px 15px;
        white-space: nowrap !important;
    }
    #cancel_button {
        background-color: #eeeeee;
        margin-right: 20px;
        &:hover {
            background-color: #cccccc;
        }
        color: #181d1f;
    }
    #apply_button {
        background-color: #4c912d;
        &:hover {
            background-color: #467c26;
        }
    }
`;

export const FooterSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 672px;
`;

export const ErrorSection = styled.div`
    position: absolute;
    width: 83%;
    top: 6%;
    ${props => (props.left ? css`left: ${props.left};` : "" )}
    background-color: ${props => (props.type === "success" ? "#ecffe9" : "#fbf4f4")};
    border: 2px solid;
    border-color: ${props => (props.type === "success" ? "#117b0f" : "#C31200")};
    border-radius: 8px;
    padding: 15px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 9999;
    div:last-child > svg {
        font-size: 22px;
        cursor: pointer;
    }
`;

export const FormErrorContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    b {
        margin-top: 3px;
        line-height: 1.1;
    }
    svg {
        margin-bottom: 5px;
        margin-right: 7px;
        color: ${props => (props.type === "success" ? "#117b0f" : "#C31200")};;
        font-size: 20px;
    }
    > p {
        margin-left: 26px;
    }
`;

export const HubServerStatus = styled.div`
    display: flex;
    align-items: center;
    > label {
        margin-bottom: 0;
        margin-left: 5px;
        font-size: 13px;
    }
    > input {
        margin-left: 5px;
    }
`;
export const CertDetailsTable = styled.table`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
    tbody {
        tr {
            td:first-child {
                font-weight: 600;
                width: 200px;
                color: #333333;
            }
            td {
                height: 20px;
            }
        }
    }
`;

export const HubParamModal = styled(Modal)`
    ${props => (props.fileUploadError ? css`max-width: 40%;margin-top: 9%;` : props.isOverwriteModel ? css`max-width: 45%;margin-top: 9%;` : "" )}
    ${props => (props.maxWidth ? css`max-width: ${props.maxWidth} !important;` : "" )}
    ${props => (props.mt ? css`margin-top: ${props.mt};` : "" )}
    > div {
        min-height: 280px;
        ${props => (props.fileUploadError ? css`border: 1px solid #808080; border-top: 7px solid #c20202;` 
        : css`border: 1px solid #808080;`)}
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 190px;` : null)}
        
    }
    #alert-content {
        margin-top: 21px;
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 8px;
    }
    #import-file-error {
        margin-top: 20px;
        margin-left: 5px;
    }
    #import-file-error-message {
        color: #c20202;
        margin-left: 5px;
        margin-top: 10px;
    }
    #model-footer-section {
        justify-content: flex-end;
        #cancel_button {
            ${props => (props.fileUploadError ? css`color: #c20202; border: 1px solid #c20202; width: 115px;` : "")}
        }
    }
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #333;
            font-size: 1.4rem;
            display: flex;
            svg {
                ${props => (props.fileUploadError ? css`color: #c20202; margin-right: 10px;` : "")}
            }
        }
    }
`;

export const FileUploadSpinner = styled.div`
    position: absolute;
    width: 70%;
    height: 95%;
    top: 0;
    z-index: 9999;
    div[class*='SpinnerDetails'] {
        width: 250px;
    }
`;

export const ErrorIconContainer = styled.span`
    font-size: 16px;
    color: #e00000;
    margin-left: 5px;
`;

export const StatusItalicTag = styled.i`
    ${props => (props.error ? css`color: #c20202;` : css`color: green;`)}
`;
